/* eslint-disable @typescript-eslint/no-var-requires */
import React, {
  FunctionComponent,
  MutableRefObject,
  useEffect,
  useRef,
} from 'react';

import './animation011.less';
import { usePlayFlag } from './../../components/topicScroll';

interface IAnimation011Item {
  icon: string;
  color: string;
  text: string;
}

interface IAnimation011Props {
  items: IAnimation011Item[];
  onCompleted: () => void;
}

const Animation011: FunctionComponent<IAnimation011Props> = ({
  items,
  onCompleted,
}) => {
  const crrRef = useRef() as MutableRefObject<HTMLDivElement>;
  const playFlag = usePlayFlag(crrRef.current as HTMLElement, '.course-body');
  const [play, setPlay] = React.useState(1);
  const startPlay = (next = 1) => {
    setPlay(next);
    next += 1;
    if (next <= items.length) {
      setTimeout(() => startPlay(next), 1200);
    } else {
      console.log('Animation011 onCompleted');
      onCompleted && onCompleted();
    }
  };
  const getImg = (img: string) =>
    require(`../../../../../assets/${img}`).default;

  useEffect(() => {
    if (playFlag) {
      startPlay();
    }
  }, [playFlag]);
  return (
    <div ref={crrRef} className="animation011 component">
      <div className="animation011-content">
        {items.map((itm: IAnimation011Item, idx: number) => (
          <div
            key={idx}
            className={`animation011-item animation ${
              play >= idx + 1 ? 'fade-in' : ''
            }`}
            style={{ paddingLeft: idx * 50 }}
          >
            <div
              className="animation011-indicate-number"
              style={{ backgroundColor: itm.color }}
            >
              <div
                className="animation011-icon"
                style={{ borderColor: itm.color }}
              >
                <img src={getImg(itm.icon)} alt="" />
              </div>
              <div className="number">0{idx + 1} </div>
            </div>
            <div
              className="animation011-text"
              dangerouslySetInnerHTML={{ __html: itm.text }}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Animation011;
